// Default State
const state = {
	items: localStorage.getItem('itemStore') ? JSON.parse(localStorage.getItem('itemStore'))  : []
}

// Module Getters
const getters = {

	getAllEntries: (state) => {
		return state.items;
	},

	getItem: (state) => (store_id, store_type) => {

		if (state.items == null) {
			return null;
		}
		var tmp = state.items.find(function (item) {
			return item.store_id == store_id && item.store_type == store_type;
		  });
		if (tmp == undefined) { tmp = null; }
		return tmp;
	}

}

// Module Actions
const actions = {

}

// Module Mutations
const mutations = {

	addActivityToStore(state, payload) {

		state.items = localStorage.getItem('itemStore') ? JSON.parse(localStorage.getItem('itemStore')) : [];

		// find the package in the store
		var tmp = this.getters.getItem(payload.store_id,payload.store_type);
		// if it's not there then create it
		if (tmp == null) {
			state.items.push({
				store_id: payload.store_id,
				store_type: payload.store_type,
				activities: []
			});
			tmp = this.getters.getItem(payload.store_id, payload.store_type);
		}

		// find the activity in the package data
		var activity = tmp.activities.find(items => items.id == payload.activity_id);

		// if it's not there then create it, otherwise update it
		if (activity == null) {
			tmp.activities.push({
				id: payload.activity_id,
				option_id: payload.option_id
			});
		} else {
			activity.option_id = payload.option_id;
		}

		saveToLocalStorage(this.getters.getAllEntries);

		return this;
	},

	removeActivityFromStore(state, payload) {

		state.items = localStorage.getItem('itemStore') ? JSON.parse(localStorage.getItem('itemStore')) : [];
		// find the package in the store
		var tmp = this.getters.getItem(payload.store_id,payload.store_type);
		if (tmp != null && tmp.activities != null) {
			tmp.activities = tmp.activities.filter(el => el.id !== payload.activity_id);
			saveToLocalStorage(this.getters.getAllEntries);
		}

		return this;
	}
}

function saveToLocalStorage(data) {
	localStorage.setItem('itemStore', JSON.stringify(data) );
}

export default {
	state,
	getters,
	actions,
	mutations
}
